import {
    SearchFieldCheckbox,
    SearchFieldSelect,
    SearchFieldsType,
} from "./SearchForm";

type Facets = {
    archived?: SearchFieldCheckbox | undefined;
    datePublished?: SearchFieldCheckbox | undefined;
    regionLocation?: SearchFieldSelect | undefined;
    resourceType?: SearchFieldSelect | undefined;
    status?: SearchFieldSelect | undefined;
    topic?: SearchFieldSelect | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};

const resolveFacetItems = (
    facets: Omit<SearchFieldsType, "query">
): Facets[] => {
    const newFacets: Omit<SearchFieldsType, "query"> = {};
    const rangeRegex = /__start$|__end$/;

    for (const [key, facet] of Object.entries(facets)) {
        if (rangeRegex.test(facet.name)) {
            const rangeName = facet.name.replace(rangeRegex, "");

            // Create range if it doesn't already exist
            if (!newFacets[rangeName]) {
                newFacets[rangeName] = {
                    ...facet,
                    facetType: facet.facetType,
                    label: facet.label.replace(rangeRegex, ""),
                };
            }

            // Set items if range start
            if (facet.name.includes("__start")) {
                newFacets[rangeName].nameStart = facet.name;
                newFacets[rangeName].idStart = facet.id;
            }

            // Set items if range end
            if (facet.name.includes("__end")) {
                newFacets[rangeName].nameEnd = facet.name;
                newFacets[rangeName].idEnd = facet.id;
            }
        } else {
            newFacets[key] = { ...facet };
        }
    }

    return Object.values(newFacets);
};

export default resolveFacetItems;
